import { computed, observable } from 'mobx';
import { autobind } from 'core-decorators';
import useMount from '@src/utils/hooks/use-mount';
import { SHARE_METHOD_CONFIG } from '@src/constants/business';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { $$tracker } from '@src/tracker';
const lang = getLanguageByPath();
/**
 * 分享
 */
class FollowUsStore {
  @observable discordLink = '';
  @observable youtubeLink = '';
  @observable twitterLink = '';

  @computed
  get itemList() {
    return SHARE_METHOD_CONFIG.filter(item => item.applyLanguages.includes(lang))
      .sort((a, b) => a.order[lang] - b.order[lang])
      .map(item => ({
        name: item.name,
        link: item.linkLocales[lang],
        img: require(`./images/${item.name}.png`),
        onClick: () => {
          $$tracker.clickMainNaviBarPlatform(item.name === 'X' ? 'Twitter' : item.name);
        }
      })
      );
  }

  /**
   * 是否展开
   * @type {boolean}
   */
  @observable isActive = false;

  /**
   * 点击切换展开状态
   */
  @autobind
  handleMouseEnter(e) {
    if (e) {
      e.preventDefault();
    }
    this.isActive = true;
  }

  @autobind
  handleMouseLeave(e) {
    if (e) {
      e.preventDefault();
    }
    this.isActive = false;
  }

  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      window.open(url);
    }
  }

  /**
   *
   * @param element {HTMLElement}
   */
  checkParentId(element, mark) {
    const parent = element.parentNode;
    if (!parent) {
      return false;
    }
    const elementId = parent.id;
    if (elementId === mark) {
      return true;
    } else {
      return this.checkParentId(parent, mark);
    }
  }

  use() {
    useMount(() => {
      const hideExpandList = e => {
        if (!this.checkParentId(e.target, 'followUs')) {
          this.isActive = false;
        }
      };

      window.addEventListener('click', hideExpandList);
      return () => {
        window.removeEventListener('click', hideExpandList);
      };
    });
  }
}

export default FollowUsStore;
